import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";
import { Provider } from "react-redux";
import ThemeProvider from "react-bootstrap/ThemeProvider";
import { msalInstance } from "./utility/msalConfig";
import { MsalProvider } from "@azure/msal-react";

import { BrowserRouter } from "react-router-dom";

// const base = process.env.PUBLIC_URL === "." ? "" : process.env.PUBLIC_URL;
const root = ReactDOM.createRoot(document.getElementById("root"));
msalInstance.initialize().then(() => {
root.render(
  <React.StrictMode>
    <ThemeProvider minBreakpoint="xxs">
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
        <BrowserRouter>
        
          <App />
        
        </BrowserRouter>
        </MsalProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);
}).catch(error => {
  console.error("MSAL initialization failed:", error);
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
